<span class="container" *ngIf="!editMode">
  <span class="value"
        *ngIf="value">
    <ng-content></ng-content>
  </span>
  <span *ngIf="!value" class="no-value">{{noValue}}...</span>
  <span class="buttons" *ngIf="!readonly">
    <button mat-icon-button
            matTooltip="Редактировать"
            (click)="onEdit($event)">
      <mat-icon>edit</mat-icon>
    </button>
  </span>
</span>

<form class="editor" *ngIf="!readonly && editMode"
      [formGroup]="form" (ngSubmit)="onSubmit($event)">
  <mat-form-field>
    <mat-label>{{label}}</mat-label>

    <input #input *ngIf="!multiline" matInput formControlName="value" type="text"
           autocomplete="off" [autofocus]="['autofocus']">

    <textarea #input *ngIf="multiline" matInput formControlName="value"
              [autofocus]="['autofocus']"
              cdkTextareaAutosize
              cdkAutosizeMinRows="{{rows}}"
              cdkAutosizeMaxRows="{{rows + 3}}"></textarea>

  </mat-form-field>
  <div class="buttons">
    <button mat-icon-button
            matTooltip="Сохранить"
            type="submit"
            (click)="onSubmit($event)">
      <mat-icon>done</mat-icon>
    </button>
    <button mat-icon-button
            matTooltip="Отмена"
            type="button"
            (click)="onCancel($event)">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</form>

